import {API_BASE_URL} from '../../commons/uri';

export const buttons = [
  {name: 'WRÓĆ NA STRONĘ GŁÓWNĄ', url: API_BASE_URL, color: 'primary'}
];

export const caption = 'UPS! Strona, której szukasz nie istnieje.';
